import { AT_DEFAULT_FILTER_RESET } from './constants';
import { IDefaultFilterResetAction } from './types';

export const defaultFilterReset = (
): IDefaultFilterResetAction => ({
        type: AT_DEFAULT_FILTER_RESET
    }
);
